import {
    QuestionAnswer,
    InsertEmoticon,
    Quiz,
    Poll,
    TextFields,
    Cloud,
    Flaky,
    TouchApp,
    Photo, QuestionMark, Mic, FormatListNumbered, PanTool, Link, WbIncandescent, Rtt
} from "@mui///icons-material";

const questionType = {
    qna: {
        text: 'Q&A',
        ////icon: <QuestionAnswer/>
    },
    toolpress: {
        text: 'Toolpress',
        //icon: <QuestionAnswer/>
    },
    quiz: {
        text: 'Quiz',
        //icon: <Quiz/>
    },
    poll: {
        text: 'Sondaggio',
        //icon: <Poll/>
    },
    colorPoll: {
        text: 'Sondaggio colorato',
        //icon: <WbIncandescent/>
    },
    reorder: {
        text: 'Riordinamento',
        //icon: <FormatListNumbered/>
    },
    wordcloud: {
        text: 'Wordcloud',
        //icon: <Cloud/>
    },
    sentiment: {
        text: 'Sentiment',
        //icon: <InsertEmot//icon/>
    },
    siNo: {
        text: 'Sí/No',
        //icon: <Flaky/>
    },
    clickTo:{
        text: 'Click To',
        //icon: <TouchApp/>
    },
    links:{
        text: 'Click To',
        //icon: <Link />,
    },
    text: {
        text: 'Testo',
        //icon: <Rtt/>
    },
    color:{
        text: 'Colora smartphone',
        //icon: <WbIncandescent />,
    },
    sendPhoto:{
        text:"Invio foto",
        //icon:<Photo/>
    },
    audio:{
        text:"Invio audio",
        //icon:<Mic/>
    },
    reserveSpot: {
        text: "Prenota il tuo posto!",
        //icon: <PanTool/>
    },
    altro:{
        text:"Altro",
        //icon:<QuestionMark/>
    },
}

export default questionType